import { render, staticRenderFns } from "./MyInspectionsView.vue?vue&type=template&id=6f198076&scoped=true"
import script from "./MyInspectionsView.vue?vue&type=script&lang=ts"
export * from "./MyInspectionsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f198076",
  null
  
)

export default component.exports